/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetReferenceableSyncEntitiesRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {GetReferenceableSyncEntitiesResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const getReferenceableSyncEntities = (request: GetReferenceableSyncEntitiesRequest, options?: CashRequestOptions) => post<GetReferenceableSyncEntitiesRequest, GetReferenceableSyncEntitiesResponse>("/2.0/cash/get-referenceable-sync-entities", request, {...options, rejectOnError: true })